import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { EditUkmResponse } from "../../constants/types";

type UpdateUkmBody = {
    id: number | string;
    formData: FormData;
};

const updateUkm = async ({ id, formData }: UpdateUkmBody) => {
    const response = await axios.post<EditUkmResponse>(
        `/api/ukm/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export default function useUpdateUkm() {
    const queryClient = useQueryClient();

    return useMutation((body: UpdateUkmBody) => updateUkm(body), {
        onSuccess: () => {
            queryClient.invalidateQueries(["ukm"]);
        },
    });
}
